import { Injectable } from '@angular/core';
import { ComponentLocationStrategy } from './component-location-strategy';

@Injectable()
export class RechteSuchergebnisLocationStrategy extends ComponentLocationStrategy {
  constructor() {
    super();
  }

  componentId(): string {
    return 'RECHTE_SUCHERGEBNIS';
  }
}
